module.exports = __webpack_public_path__ + "assets/img/img-footer-use01.svg";